import { CheckCircle2, RefreshCw, Rocket } from "lucide-react";

// LP2 – Abschlussblock, finaler Conversion-Fokus. Erscheint NUR nach „Mitarbeiter
// zuweisen". EINE Botschaft: die automatische Wiedervorlage. EIN CTA. EIN Screenshot
// (beschnitten + vergrößert auf „Wiedervorlage / jährlich"). Keine Nutzereingabe,
// keine neue Logik – nutzt ausschließlich die vorhandene Prop onTest.

const STATUS = [
  { Icon: CheckCircle2, label: "Gefährdungsbeurteilung erstellt", recur: false },
  { Icon: CheckCircle2, label: "Unterweisung zugewiesen", recur: false },
  { Icon: RefreshCw, label: "Wiedervorlage aktiv", recur: true },
  { Icon: CheckCircle2, label: "Nachweise WORM-archiviert", recur: false },
];

export default function ConversionBlock({ onTest }) {
  return (
    <section className="wrap conv reveal in" data-testid="lp2-conversion">
      {/* HERO – dunkle Karte */}
      <div className="conv-card conv-hero">
        <span className="pill"><CheckCircle2 size={14} /> Erledigt</span>
        <h2 data-testid="lp2-conversion-headline">
          Geschafft. Ab jetzt denkt CLartext für Sie mit.
        </h2>
        <p className="csub">
          Ihre Dokumentation ist erstellt und den richtigen Mitarbeitern zugewiesen.
        </p>
      </div>

      {/* WOW – eine Botschaft: automatische Wiedervorlage */}
      <div className="conv-wow">
        <header className="conv-wow-head">
          <h3>
            Wenn Unterweisungen wieder fällig werden, kümmert sich CLartext automatisch darum.
          </h3>
          <p>
            CLartext legt Unterweisungen im richtigen Intervall erneut vor. Ihre Mitarbeiter
            erhalten sie automatisch – ohne Kalender, Excel-Listen oder Erinnerungen.
          </p>
        </header>

        <div className="conv-statusbar" data-testid="lp2-conv-statusbar">
          {STATUS.map(({ Icon, label, recur }) => (
            <span className={`conv-status${recur ? " conv-status--recur" : ""}`} key={label}>
              <Icon size={16} />
              <span>{label}</span>
            </span>
          ))}
        </div>

        <figure className="conv-shot-single" data-testid="lp2-conv-shot">
          <img
            src="/landing-screens/conv-wiedervorlage-focus.jpg"
            alt="Wiedervorlage aktiv – Intervall jährlich"
            width="1130"
            height="632"
            loading="lazy"
            decoding="async"
            data-testid="lp2-conv-shot-img"
          />
        </figure>
      </div>

      {/* Stärkster Satz */}
      <p className="conv-power" data-testid="lp2-conv-power">
        Sie kümmern sich einmal darum. CLartext kümmert sich ab dann dauerhaft darum.
      </p>

      {/* Abschluss-CTA – dunkle Karte, EIN Button */}
      <div className="conv-card conv-final">
        <h2>Weniger Bürokratie. Mehr Zeit fürs Geschäft.</h2>
        <p className="csub">
          Keine offenen Aufgaben im Kopf. Keine verpassten Fristen. Keine Angst vor der BG-Prüfung.
        </p>
        <div className="conv-cta">
          <button className="btn btn-light btn-lg" data-testid="lp2-final-cta" onClick={onTest}>
            <Rocket size={18} /> 14 Tage kostenlos testen
          </button>
        </div>
        <div className="conv-trust" data-testid="lp2-conv-trust">
          WORM-archivierte Nachweise · Serverstandort Deutschland · DSGVO-konforme Datenverarbeitung
        </div>
      </div>
    </section>
  );
}
